<template>
    <div>
        <app-title text="Tareas por confirmar" />
        <app-resolved-tasks-filters @filter="onFilter" />
        <app-created-tasks-resolved-list
            :data="data"
            @change-page="changePage"
            @approve-task="startApproveTask"
            @reject-task="startRejectTask"
            @sort="onSort"
        />
        <!-- pop up's -->
        <app-pop-up title="Confirmación de la solución" id="approve-task">
            <div slot="body">
                <h2>¿Esta seguro que desea aprobar la solución de la tarea?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <b-button variant="confirm" @click="approveTask()"
                    >Aprobar</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up
            title="Rechazo de la solución"
            id="reject-task"
            size="large"
        >
            <div slot="body">
                <b-row>
                    <b-col>
                        <h5>
                            ¿Esta seguro que desea rechazar la solución de la
                            tarea?
                        </h5>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h6>Seleccione el nuevo responsable</h6>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="4">
                        <app-form-select-input
                            label="Cargo a asignar"
                            :options="belowLevelPositions"
                            v-model="positionId"
                            @change="
                                !!positionId
                                    ? loadUsersByPosition(positionId)
                                    : cleanFormReject()
                            "
                        />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <app-form-select-input
                            label="Usuario Responsable"
                            :options="users"
                            v-model="rejectTask.userId"
                            :hasError="$v.rejectTask.userId.$error"
                            errorMessage="Debe seleccionar el usuario"
                            @change="$v.rejectTask.userId.$touch()"
                            :required="true"
                            :disabled="!positionId"
                        />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <app-datepicker-native
                            label="Fecha de vencimiento"
                            :with-time="false"
                            v-model="rejectTask.dueDate"
                            :required="true"
                            :hasError="$v.rejectTask.dueDate.$error"
                            @input="$v.rejectTask.dueDate.$touch()"
                            errorMessage="Debe seleccionar la fecha de vencimiento"
                            :min="minDate"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <app-form-textarea-input
                            label="Justificación del rechazo"
                            v-model="rejectTask.notes"
                            :required="true"
                            :has-error="$v.rejectTask.notes.$error"
                            error-message="Debe escribir la justificación del rechazo de la solución"
                        />
                    </b-col>
                </b-row>
            </div>
            <div class="buttons" slot="buttons">
                <b-button variant="danger" @click="reject()"
                    ><i class="fa fa-times-circle-o"></i> Rechazar</b-button
                >
            </div>
        </app-pop-up>
    </div>
</template>

<script>
import CreatedTasksResolvedList from "./CreatedTasksResolvedList/CreatedTasksResolvedList.vue";
import ResolvedTasksFilters from "../ResolvedTasks/ResolvedTasksFilters/ResolvedTasksFilters.vue";
import tasksRepository from "../../../../repositories/tasks.repository.js";
import userRepository from "../../../../repositories/users.repository.js";
import { required } from "vuelidate/lib/validators";
import DatePicker from "../../../UI/Controls/DateTimePicker/DateTimePicker.vue";
import { mapActions, mapGetters } from "vuex";
import * as actionTypes from "../../../../store/actionTypes";

export default {
    components: {
        appCreatedTasksResolvedList: CreatedTasksResolvedList,
        appDatePicker: DatePicker,
        appResolvedTasksFilters: ResolvedTasksFilters
    },
    data() {
        return {
            data: {},
            filters: null,
            page: 1,
            selectedTask: "",
            positionId: "",
            users: [],
            rejectTask: {
                userId: "",
                dueDate: "",
                notes: ""
            },
            sort: {
                sortBy: "name",
                sortDir: "asc"
            }
        };
    },

    validations: {
        rejectTask: {
            userId: { required },
            dueDate: { required },
            notes: { required }
        }
    },
    methods: {
        loadTasks() {
            const tr = { ...tasksRepository };
            const filters = {
                ...this.filters,
                status: "solved",
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir
            };
            tr.getTasksByUser(this.user.id, filters, this.page)
                .then(data => {
                    const tdata = data.data.map(item => ({
                        ...item,
                        _rowDetails: true
                    }));

                    this.data = { ...data, data: tdata };
                })
                .catch(error =>
                    toastr.error("Ocurrió un error al cargar las tareas")
                );
        },
        onFilter(filters) {
            this.filters = filters;
            this.loadTasks();
        },
        changePage(page) {
            this.page = page;
            this.loadTasks();
        },
        startApproveTask(task) {
            this.selectedTask = task;
            this.$bus.$emit("approve-task.open");
        },
        approveTask() {
            const tr = { ...tasksRepository };
            const formData = new FormData();

            formData.append("approvedById", this.user.id);
            formData.append("task", this.selectedTask);
            tr.approveTask(this.selectedTask.id, formData)
                .then(data => {
                    toastr.success(
                        "Se aprobó correctamente la solución de la tarea"
                    );
                    this.loadTasks();
                    this.$bus.$emit("approve-task.close");
                })
                .catch(error => toastr);
        },
        startRejectTask(task) {
            this.selectedTask = task;
            this.positionId = task.assignee.position_id;
            this.rejectTask.userId = task.assignee_id;
            this.$bus.$emit("reject-task.open");
        },
        loadUsersByPosition(positionId) {
            this.$v.$reset();
            const ur = Object.assign({}, userRepository);
            ur.loadUsersByPosition(positionId)
                .then(data => {
                    this.users = data;
                })
                .catch(error => {
                    toastr.error("Error al cargar los usuarios de este cargo");
                });
        },
        cleanFormReject() {
            this.users = [];
            this.positionId = "";
            this.rejectTask.userId = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        reject() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }
            const formData = new FormData();

            formData.append("userId", this.user.id);
            formData.append("reassignedId", this.rejectTask.userId);
            formData.append("newDueDate", this.rejectTask.dueDate);
            formData.append("notes", this.rejectTask.notes);

            const tr = { ...tasksRepository };
            tr.rejectTask(this.selectedTask.id, formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(
                            "Se rechazó correctamente la solución de la tarea"
                        );
                        this.loadTasks();
                        this.$bus.$emit("reject-task.close");
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al rechazar la solución de la tarea");
                });
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadTasks();
        }
    },

    computed: {
        ...mapGetters(["positions"]),
        belowLevelPositions() {
            if (!this.user.position) return [];

            return this.positions.filter(
                item => item.level <= this.user.position.level
            );
        },
        minDate(){
            return moment().add(1,"days").format("YYYY-MM-DD");
        }
    },
    mounted() {
        this.loadTasks();
        this.load('positions');
    }
};
</script>